import React from 'react';

import {TabsListingItem} from './TabsListingItem';
import {HotspotTab} from '@ael/core-api';
import classNames from 'classnames';
import * as Immutable from 'immutable';

import './TabsListing.scss';

interface TabsListingProps {
  show?: boolean;
  tabs: Immutable.List<HotspotTab>;
  selectedTabIndex?: number;
  onSelect: (tabIndex: number) => void;
}

export const TabsListing: React.FC<TabsListingProps> = ({ tabs, onSelect, selectedTabIndex, show }) => {
  return (
    <div
      className={classNames('tabs-listing', {
        'tabs-listing--collapsed': !show,
      })}
    >
      <div className="tabs-listing__content">
        {tabs.map((tab: HotspotTab, index: number) => (
          <TabsListingItem
            key={tab.id}
            tab={tab}
            onClick={() => onSelect(index)}
            isActive={index === selectedTabIndex}
          />
        ))}
      </div>
    </div>
  );
};
